import fotoTentang from "../../assets/home/foto-tentang.png";
// import AOS from "aos";
// import "aos/dist/aos.css";
import decoreTentang from "../../assets/home/decore-tentang.png";

const Tentang = () => {
  // AOS.init();
  // AOS.refresh();
  // AOS.refreshHard();
  return (
    <>
      <div className="pt-12 lg:pt-20" id="profil">
        <div className="flex flex-col-reverse lg:grid-rows-none lg:grid lg:grid-cols-3">
          <div className="col-span-1 relative">
            <img
              className="lg:w-[500px] w-[300px] mt-12"
              data-aos="fade-right"
              data-aos-duration="1500"
              data-aos-offset="400"
              src={fotoTentang}
              alt=""
            />
            <img
              src={decoreTentang}
              alt=""
              className="absolute -top-10 -z-10"
            />
          </div>
          <div
            className="lg:px-0 px-10 col-span-2"
            data-aos="fade-left"
            data-aos-duration="1500"
            data-aos-offset="500"
          >
            <h1 className="my-4 lg:my-0 lg:mb-2 text-center lg:text-left lg:text-5xl text-2xl font-bold noto-sans">
              Tentang W&W
            </h1>
            <p className="text-justify lg:text-2xl text-base lg:mt-4 lg:pr-32 open-sans">
              Waste and Wishes merupakan perusahaan yang terdaftar sebagai PT.
              Sampah dan Harapan Indonesia sebagai Start-up Company yang
              bergerak di bidang pengelolaan sampah makanan dengan mengedepankan
              aspek keberlanjutan dan berbasis green entrepreneurship.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tentang;
